import { Component, Fragment } from 'react';
import EditButton from 'Components/Table/EditButton';
import DeleteButton from 'Components/Table/DeleteButton';
import DataTable from 'Container/DataTable/DataTableContainer';
import formUrlParams from 'Helpers/urlform';
import AddManageAdmin from 'Container/ManageAdmin/AddManageAdminContainer';
import { ReactComponent as Add } from 'assets/images/svg/Frame (21).svg';
import Pagination from 'Components/Pagination';
import EditManageAdmin from 'Container/ManageAdmin/EditManageAdminContainer';
import Popup from 'Components/Common/PopUp';
import { debounce } from 'lodash';
import { CSVLink } from 'react-csv';
import { SUPER_ADMIN } from 'Helpers/apiurl';
import { ModuleActions } from 'Constants/Modules.constants';
import { tableConstants } from 'Constants';
import { convertUTCTOLocalTimeStamp } from 'Components/Common/TimeStamp';
import dateFormat from 'dateformat';

/**
 * @file ManageAdmin Component
 * Admin can view, update and delete the details
 * @module 6.ManageAdmin
 * @extends Component
 */

export default class ManageAdmin extends Component {
  constructor(props) {
    super(props);
    const model = {
      headers: [
        {
          className: tableConstants.NAME_WIDTH,
          title: 'Name',
          chooseOption: {
            name: 'nameSearch' /* API param name */,
            Component: 'Search',
            dispatchFunction: this.handleSearch
          },
          combineapidata: [ 'name', 'image' ],
          accessor: 'name' /* API response */,
          cell: {
            type: 'image-with-name'
          },
          sortOption: true,
          tooltip: true
        },
        {
          className: tableConstants.NAME_WIDTH,
          title: 'Email',
          chooseOption: {
            name: 'emailIdSearch',
            Component: 'Search',
            dispatchFunction: this.handleSearch
          },
          accessor: 'emailId',
          sortOption: true,
          tooltip: true
        },
        {
          className: tableConstants.DEFAULT_WIDTH,
          title: 'Access Level',
          chooseOption: {
            name: 'accessLevelSearch',
            Component: 'DropDown',
            DropdownText:'All',
            dispatchFunction: this.handleSearch,
            optionRender: this.createAdminRoles
          },
          accessor: 'accessLevel',
          sortOption: true,
          cell: function(rowDetails) {
          const { accessLevel, index, roleName } = rowDetails;
            return <td key={ index } className={ tableConstants.DEFAULT_WIDTH }>{accessLevel || roleName}</td>;
          },
      },
        {
          className: 'action',
          title: 'Status',
          chooseOption: {
            name: 'statusSearch',
            Component: 'DropDown',
            DropdownText:'All',
            dispatchFunction: this.handleSearch,
            optionRender: this.createStatus
          },
          accessor: 'isActive',
          cell: function(rowDetail) {
            const { content, index } = rowDetail;
            const status =
              content === 1 ? (
                <Fragment>
                  <span className='active'>Active</span>
                </Fragment>
              ) : (
                <Fragment>
                  <span className='inactive'>Inactive</span>
                </Fragment>
              );
            return <td key={ index } className='action'>{status}</td>;
          },
          //sortOption: true,
        },
         {
          className:tableConstants.NAME_WIDTH,
          title: 'Created Date',
          // chooseOption: {
          //   name: 'createdDateSearch',
          //   Component: 'DateTimeRangeComponent',
          //   dispatchFunction: this.handleDateSearch
          // },
          cell: function (rowDetails) {
            const { index, content } = rowDetails;
            const val = content && content.replace('T',' ')
            const time = content && convertUTCTOLocalTimeStamp(val)
            return (
              <td key={ index } className={ tableConstants.NAME_WIDTH }>
                {content && dateFormat(time, 'mmm d, yyyy / hh:MM:ss TT ')}
              </td>
            );
          },
          accessor: 'createdAt',          
        },
        {
          className:tableConstants.NAME_WIDTH,
          title: 'Updated Date',
          // chooseOption: {
          //   name: 'createdDateSearch',
          //   Component: 'DateTimeRangeComponent',
          //   dispatchFunction: this.handleDateSearch
          // },
          cell: function (rowDetails) {
            const { index, content } = rowDetails;
            const val = content && content.replace('T',' ')
            const time = content && convertUTCTOLocalTimeStamp(val)
            return (
              <td key={ index } className={ tableConstants.NAME_WIDTH }>
                {content && dateFormat(time, 'mmm d, yyyy / hh:MM:ss TT ')}
              </td>
            );
          },
          accessor: 'updatedAt',    
        },
        {
          className: 'action',
          title: 'Action',
          accessor: 'id',
          cell: rowDetail => {
            const { index, id, rowIdx, profile, ...rest } = rowDetail;
            const permission = profile && profile[ 'Manage admin' ];
            const disable = rowDetail.userName === SUPER_ADMIN ? true : false;
            return (
              <td key={ index } data-row={ rowIdx } className='action'>
                { permission && !permission[ ModuleActions.edit ] && !permission[ ModuleActions.delete ] && 'N/A' }
                { permission && permission[ ModuleActions.edit ] && <EditButton
                  id={ id }
                  { ...rest }
                  getActiveEditData={ this.getActiveEditData }
                  editClass='editadmin'
                  checkPermission={ permission && permission[ ModuleActions.edit ] }
                  disable = { disable }
                /> }
                { permission && permission[ ModuleActions.delete ] && <DeleteButton
                  remainningRecords={ this.props.responseArray.length }
                  activeQuery={ this.state.filtered }
                  deleteActionListener={ this.props.deleteAdminUser }
                  id={ id }
                  checkPermission={ permission && permission[ ModuleActions.delete ] }
                  currentPage = { this.props.currentPage }
                  disable = { disable }
                /> }
              </td>
            );
          }
        }
      ],
      filtered: [],
      responseArray: [],
      pageLimit: 10,
      activeEditData: '',
      addAdminFormStatus: false,
      editAdminFormStatus: false,
      deletepopup: false,
      activeSort: {},
    };
    this.state = model;
  }

  /**
   * @event componentDidMount
   * @summary API call to fetch admin  details
   * @return {Object} return manage admin object
   */
  componentDidMount() {
    this.props.fetchAdminUser();
    this.props.exportAdmin();
  }

  getActiveEditData = data => {
    this.setState({ activeEditData: data, editAdminFormStatus: true }, () => {
      document.getElementById(data.editClass).classList.add('open');
    });
  };
  
  closePopUp = event => {
    event.preventDefault();
    this.setState({
      deletepopup: false
    });
  };

  openPopUp = event => {
    event.preventDefault();
    this.setState({
      deletepopup: true
    });
  };

  createStatus = () => {
    const statusArray = [ 'Inactive', 'Active' ];
    return statusArray.map((admin, index) => {
      return (
        <option key={ index } value={ index }>
          {admin}
        </option>
      );
    });
  };

  /**
   * @method debounceEvent 
   * @summary used to delay the event for some limit
   * @param {event} event - React onChange event
   * @return { function } debouncedEvent
   */
  debounceEvent(...args) {
    this.debouncedEvent = debounce(...args);
    return e => {
      e.persist();
      return this.debouncedEvent(e);
    };
  }

  /**
   * @method createAdminRoles
   * @summary Render access level options dynamically based on admin roles
   * @return {none} undefined
   */

  createAdminRoles = () => {
    const { adminRoles } = this.props;
    if (!adminRoles || adminRoles.length <= 0) return null;
    return adminRoles.map((admin, index) => {
      return (
        <option data-rolename={ admin.roleName } key={ index } value={ admin.roleName }>
          {admin.roleName}
        </option>
      );
    });
  };

  /**
   * @method formUrlParams
   * @param {name} name - Query string name
   * @param {value} value - Query string value
   * @param {rest} rest - Rest object except name and value
   * @summary Construct the query string based on user selection
   * @return {function} call fetch admin user api after change local state
   */

  formUrlParams = (name, value, rest) => {
    const { filtered, activeSort } = this.state;
    const filterResponse = formUrlParams(filtered, name, value);
    this.setState({ filtered: filterResponse, ...rest }, () => {
      let updatedFilter = this.state.filtered;
      if(activeSort && activeSort.id){
        updatedFilter = [
          ...this.state.filtered,
          activeSort
        ]
      }
      this.props.fetchAdminUser(updatedFilter);
      this.props.exportAdmin(updatedFilter);
    });
  };

  /**
   * @method sortTable
   * @summary sort for view data
   * @param {name} sortAttribite - Query string name
   * @return { function } formUrlSort
   */
  sortTable = (sortAttribite) => {
    const { activeSort } = this.state
    const sortType = (activeSort.id === sortAttribite) ? 
    ((activeSort.value && activeSort.value == 'desc') ? 'asc' : 'desc') : 'asc';
    this.setState({
      activeSort: { id: sortAttribite, value: sortType },
    }, () => {
      this.formUrlSort();
    })
  }

  /**
   * @method formUrlSort
   * @summary Construct the query string based on user selection
   * @return {function} call fetch admin user api after change local state
   */
  formUrlSort = () => {
    const updatedFilter = [
      ...this.state.filtered,
      this.state.activeSort
    ]
    this.props.fetchAdminUser(updatedFilter);
    this.props.exportAdmin(updatedFilter);
  }

  /**
   * @method handleSearch
   * @summary set the username and password state
   * @param {event} event - React onChange event
   * @return { function } formUrlParams
   */
  handleSearch = event => {
    const { name, value } = event.target;
    this.formUrlParams(name, value);
  };

  /**
   * @method hanldeAddAdmin
   * @summary open admin popup based click event
   * @return {none} undefined
   */

  hanldeAddAdmin = () => {
    this.setState({ addAdminFormStatus: true }, () => {
      document.getElementById('addadmin').classList.add('open');
    });
  };

  /**
   * @method setPageLimit
   * @summary set page limit for view data per page
   * @param {name} name - Query string name
   * @param {value} value - Query string value
   * @return { function } formUrlParams
   */

  setPageLimit = (name, value) => {
    this.formUrlParams(name, value, { pageLimit: value });
  };

  /**
   * @method closeAddAdmin
   * @summary close add admin popup
   * @return { object } updated manage admin state
   */

  closeAddAdmin = () => {
    this.setState({ addAdminFormStatus: false, filtered: [] });
  };

  /**
   * @method closeEditAdmin
   * @summary close edit admin popup
   * @return { object } updated manage admin state
   */

  closeEditAdmin = () => {
    this.setState({ editAdminFormStatus: false });
  };

  render() {
    const {
      responseArray,
      totalRecords,
      currentPage,
      loading,
      profile,
      exportAdminData,
    } = this.props;
    const { addAdminFormStatus, editAdminFormStatus, deletepopup } = this.state;
    const Permission = profile && profile[ 'Manage admin' ];
    return (
      <Fragment>
        <div className='grid admin pageContainer_inner'>
          <div className='heading-block gap-10'>
            <div className='block_flex'>
              <h4>Manage Admin</h4>
            </div>
            <div className='block_flex'>
            { exportAdminData && exportAdminData.length !== 0 && <CSVLink
                  data = { exportAdminData }
                  filename = { 'Admin Details.csv' }
                  className = 'btn btn_green'
                >
                  Export To CSV
                </CSVLink>
            }
            {addAdminFormStatus && (
              <AddManageAdmin
                optionRender={ this.createAdminRoles }
                closeAddAdmin={ this.closeAddAdmin }
                filterVal = { this.state.filtered }
              />
            )}
            {editAdminFormStatus && (
              <EditManageAdmin
                { ...this.state.activeEditData }
                closeEditAdmin={ this.closeEditAdmin }
                filterVal = { this.state.filtered }
              />
            )}
            {Permission && Permission[ ModuleActions.create ] && (
              <button className='btn btn_primary' onClick={ this.hanldeAddAdmin }>
                <Add />
                Add Admin
              </button>
            )}
            </div>
          </div>
          <div className='responsive-table ctTableBox'>
            <DataTable
              className='data-table'
              tableClassName ='col-s'
              headers={ this.state.headers }
              data={ responseArray }
              noData='No records!'
              loading={ loading }
              sortTable = { this.sortTable }
              activeSort={ this.state.activeSort }
            />
             <Pagination
            handleClick={ this.formUrlParams }
            totalRecords={ totalRecords }
            initialPage={ currentPage }
            setPageLimit={ this.setPageLimit }
            pageLimit={ this.state.pageLimit }
          />
          </div>
        </div>
        {deletepopup && (
          <Popup
            popupText='Are you sure you want to delete this?'
            handleYes={ this.props.deleteAdminUser }
            handleCancel={ this.closePopUp }
          />
        )}
      </Fragment>
    );
  }
}
